export const COMPACT_CURRENCY_COLUMN = Object.freeze({
  width: 88,
  minWidth: 88,
  maxWidth: 88,
  headerTooltip: 'Currency',
});
